import React, { ReactElement } from 'react';

import Markdown from '@components/utils/Markdown';
import { Modal } from '@components/Modal/next/Modal';

import { ContentInfo } from './style';

const staticProps = {
  width: 833,
};
const InfoModal = ({
  title,
  content,
  onCancel,
  ...rest
}: {
  title?: ReactElement | string;
  content: React.ReactNode;
  onCancel?(): void;
}) => {
  const isString = typeof content === 'string';
  return (
    <Modal
      title={title}
      onCancel={onCancel}
      borderRadius={8}
      {...staticProps}
      {...rest}
    >
      <ContentInfo>
        {isString ? <Markdown text={content} /> : content}
      </ContentInfo>
    </Modal>
  );
};

export default InfoModal;
